import { ReactNode } from "react"
import type { PropsWithChildren } from "react";

export function getTextContent(n: ReactNode): string {
  if (n==null) return ''

  switch (typeof n) {
      case 'string':
      case 'number':
          return n.toString()

      case 'boolean':
          return ''

      case 'object': {
          if (n instanceof Array) {
              return n.map(getTextContent).join('')
          }

          if ('props' in n && n.props as PropsWithChildren) {
            return getTextContent((n.props as PropsWithChildren).children);
          }
      }
          // eslint-ignore-line no-fallthrough
      default:
          return ''
  }
}